/**
 * Запись прохождения обучения, готовая к просмотру.
 *
 * Главы 2-3 начинаются со снимка партии (LOAD_STATE с полным gameState), а в
 * снимке сохранен режим живой главы — gameType LOCAL. LOAD_STATE берет режим
 * из снимка, и просмотр на первом же действии превратился бы в живую
 * локальную партию: вместо проигрывателя записи запустились бы боты. Режим из
 * снимка поэтому убирается — остается выставленный снаружи REPLAY.
 *
 * Правило обработки — только для записей обучения: запись сетевого матча
 * снимка с режимом не содержит, а сам редьюсер LOAD_STATE менять нельзя —
 * сетевая партия получает свой режим именно через LOAD_STATE от сервера.
 * Исходный массив не меняется.
 */
export const prepareTutorialReplayActions = (actions) => (actions || []).map((action) => {
  const gameState = action?.type === 'LOAD_STATE' ? action.payload?.loadedState?.gameState : null;
  if (!gameState || !('gameType' in gameState)) {
    return action;
  }
  // eslint-disable-next-line no-unused-vars
  const {gameType, ...gameStateWithoutType} = gameState;
  return {
    ...action,
    payload: {
      ...action.payload,
      loadedState: {...action.payload.loadedState, gameState: gameStateWithoutType},
    },
  };
});
